import type { ResolvedPos } from '@tiptap/pm/model';

/** Depth of the nearest enclosing `sectionNode`, or `null` if outside any section. */
export function findSectionDepth($pos: ResolvedPos): number | null {
  for (let depth = $pos.depth; depth > 0; depth--) {
    if ($pos.node(depth).type.name === 'sectionNode') return depth;
  }
  return null;
}
